export default __webpack_public_path__ + "static/media/logo-ppi.083a386c.svg";